import { useContext } from "react";
import { WorkflowContext } from "./WorkflowContext";

// Custom hook to use the workflow
export const useWorkflow = () => {
  const workflow = useContext(WorkflowContext);
  return workflow;
};
